export function firstMediaUrl(value) {
  return String(value || '').split(/[,，]/).map(item => item.trim()).find(Boolean) || ''
}

export function courseImage(item) {
  return firstMediaUrl(item?.images || item?.curriculumImages || item?.image || item?.cover)
}

export function bannerImage(item) {
  return firstMediaUrl(item?.image || item?.images || item?.img || item?.bannerImg || item?.picUrl || item?.cover)
}

export function normalizeCourse(item) {
  return { ...item, images: courseImage(item) }
}
